// @import dependencies
import React, { CSSProperties, useState } from 'react'
// @end dependencies

// @import components
import AppContainer from 'app_components/layouts/app'
import BreadcrumbComponent from 'app_components/commons/breadcrumb';
// @end components

// @import types
// @end types

// @import services
// @end services

// @import hooks
import { useTranslation } from 'react-i18next';
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './PortfolioScreen.scss'
import PortfolioModule from 'app_components/modules/campus/academic/portfolio';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import BulkUploadModalModule from 'app_components/modules/admin/bulkUploadModal';
import { ScreenNotificationsUtil } from 'app_utils/screenNotification';
import { Link } from 'react-router-dom';
import { routingService } from 'app_services/routingService';
// @end styles

interface IPortfolioScreenProps {
  className?: string
  style?: CSSProperties
  id?: string

}

const PortfolioScreen: React.FC<IPortfolioScreenProps> = (props) => {

  const [uploadBulkFormStatus, setUploadBulkFormStatus] = useState<boolean>(false)
  const {t} = useTranslation();

  const screenNotifications: ScreenNotificationsUtil = new ScreenNotificationsUtil()

  const handleCloseUploadBulkModal = (data: any) => {
    setUploadBulkFormStatus(false)
    if (data?.status === true) {
      screenNotifications.fireToast({
        'message': 'El archivo se ha cargado, para verificar el proceso ve al log de carga',
        'status': 'success'
      })
    }
  }

  return(
    <AppContainer>
      <div
        className={`portfolio_screen-layout ${props.className ? props.className : ''}`}
        style={props.style}
        id={props.id}
      >
        <BreadcrumbComponent links={['#']} texts={[`${t('components.breadcrumb.portfolio')}`]} />
        <div
          className='d-flex justify-content-end mb-3'
          style={{gap: '10px'}}
        >
          <ButtonComponent
            variant='primary'
            onClick={() => setUploadBulkFormStatus(true)}
          >
            Subir archivo
          </ButtonComponent>
          <Link
            className=''
            to={routingService.getSecurePath('/admin/document-processor/Portfolio')}
            target="_blank"
          >
            <ButtonComponent
              variant='primary'
            >
              Ver logs
            </ButtonComponent>
          </Link>
        </div>
        <PortfolioModule
          hideTitle
        />
        {uploadBulkFormStatus && (
            <BulkUploadModalModule
              open={uploadBulkFormStatus}
              handleClose={handleCloseUploadBulkModal}
              header={{
                title: 'Subir archivo de portafolio',
                closeButton: true
              }}
              endpoint={{
                method: 'POST',
                url: '/api/admin/portfolio-program/upload-file',
                params: {
                  sendEmail: false
                }
              }}
              showErrors={false}
            />
          )}
      </div>
    </AppContainer>
  );
}

export default PortfolioScreen;
